import type React from "react";

interface ComposedProviderProps {
  providers: React.ComponentType<{ children: React.ReactNode }>[];
  children: React.ReactNode;
}

export function ComposedProvider({
  providers,
  children,
}: ComposedProviderProps) {
  return providers.reduceRight(
    (acc, Provider) => <Provider key={Provider.name}>{acc}</Provider>,
    children
  );
}
